import { GfsTargetOrganismSelection } from "@/services/backend/gfs/offer/types";

export const defaultGfsOfferSubject = "Angebot zum Schutz vor Schädlingen";

export function buildGfsOfferTitle(
  selection: GfsTargetOrganismSelection,
  fallbackOrganisms: string[],
): string {
  const labels = targetOrganismTitleLabels(selection);
  const organismText = targetOrganismText(labels, fallbackOrganisms);

  return `<p>Angebot zur Bekämpfung von ${escapeHtml(organismText)}</p>`;
}

export function buildGfsOfferSubject(
  selection: GfsTargetOrganismSelection,
  fallbackOrganisms: string[],
): string {
  const labels = targetOrganismTitleLabels(selection);
  return `Angebot zum Schutz vor ${targetOrganismText(labels, fallbackOrganisms)}`;
}

export function hasRenderableGfsHtml(value: string): boolean {
  return (
    value
      .replace(/<[^>]*>/g, " ")
      .replace(/&nbsp;/g, " ")
      .trim() !== ""
  );
}

function targetOrganismTitleLabels(
  selection: GfsTargetOrganismSelection,
): string[] {
  const labels: string[] = [];
  const seen = new Set<string>();
  const add = (value: string) => {
    const label = value.trim();
    const key = label.toLowerCase();
    if (!label || seen.has(key)) {
      return;
    }
    seen.add(key);
    labels.push(label);
  };

  selection.pestGroups.forEach((group) => add(group.name));
  [...selection.pestCategories, ...selection.pestIndicators].forEach((pest) => {
    const name = pest.name.trim();
    const technicalTerm = pest.technicalTerm?.trim();
    add(name && technicalTerm ? `${name} (${technicalTerm})` : name);
  });

  return labels;
}

function joinGerman(values: string[]): string {
  if (values.length <= 1) {
    return values[0] ?? "";
  }
  if (values.length === 2) {
    return values.join(" und ");
  }
  return `${values.slice(0, -1).join(", ")} und ${values[values.length - 1]}`;
}

function targetOrganismText(
  labels: string[],
  fallbackOrganisms: string[],
): string {
  const fallbackLabels = labels.length
    ? labels
    : fallbackOrganisms.map((organism) => organism.trim()).filter(Boolean);
  return fallbackLabels.length ? joinGerman(fallbackLabels) : "Schädlingen";
}

function escapeHtml(value: string): string {
  return value.replace(
    /[&<>"']/g,
    (character) =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      })[character] ?? character,
  );
}
